import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import Button from './button';

const Article = Styled.article`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
color: var(--color-primary);
padding: 2rem 2rem;
padding: 8rem 0;
& > * {&:nth-child(2) {margin: 4rem 0;}}
`;

const Heading = Styled.h2`
color: ${color.primary};
max-width: 20ch;
line-height: 1.2;
font-weight:Bold;
font-size: 4rem;
`;

const Paragraph = Styled.p`
font-size: 2rem;
max-width: 40ch;
line-height: 1.5;
margin: 3rem 0;
color:${color.primary};
`;

const Footer = Styled.footer``;

const ServiceText = ({ heading, paragraph }) => {
  return (
    <Article>
      <div>
        <Heading>{heading || 'Services tailored to your needs'}</Heading>
        <Paragraph>
          {paragraph ||
            'Schedule one-off or recurring home visits. An experienced member of our team will spend time with your pet, feed them, change cat litter trays, take the dog for a walk, and anything else you need.'}
        </Paragraph>
        <Footer>
          <Button
            type={'primary'}
            text={'Schedule a visit'}
            link={{ path: '/schedule' }}
            rounded
          />
        </Footer>
      </div>
    </Article>
  );
};

export default ServiceText;
